import React, { useRef } from "react";
import Image from "next/image";
import { useMutation } from "@apollo/client";
import css from "./.module.scss";
import {
  addImgReportedID,
  CloudfrontImageLoader,
  financialFormat,
  getStoredImgsReportedIDs,
} from "../../../lib/helpers";
import { getImageSrc, Listing } from "../ListingCard";
import { REPORT_IMAGES_ISSUE } from "../../../graphql/mutations/report";
import { useAuthState } from "../../../contexts/auth/auth.provider";
import { AppLink } from "../../new-resolver/app.ink";
import { usePath } from "../../../contexts/path/path";

function SpecialListing({ listing }) {
  const image = getImageSrc(listing.imgs);
  const imageWrapper = useRef();
  const token = useAuthState("token");
  const { updateContext } = usePath();
  const [reportImagesIssue] = useMutation(REPORT_IMAGES_ISSUE, {
    skip: !token,
    context: { token },
  });

  return (
    <AppLink
      onClick={() => {
        updateContext({ listing });
      }}
      path={listing.path}
    >
      <div ref={imageWrapper} className={css.imageWrapper}>
        <Image
          loader={CloudfrontImageLoader}
          src={image || "villa-default.png"}
          onError={() => {
            const reportedImgs = getStoredImgsReportedIDs();
            if (!(reportedImgs && reportedImgs[image]) && token) {
              addImgReportedID(image);
              reportImagesIssue({
                variables: {
                  listing_id: listing.id,
                  images: image,
                },
              });
            }
          }}
          fill
          alt={listing.title || ""}
          sizes="(max-width: 600px) 40vw, 100vw"
          priority
        />
        <div className={css.overlay}>
          <div className={css.title}>
            <div
              className={
                css.sov /*sov_campaign_id ? css.sov : css.specialText*/
              }
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                  />
                </svg>
              </span>
              <p> مميز</p>
            </div>
          </div>
          <div className={css.footer}>
            <span className={css.price}>
              {financialFormat(listing.price)} ريال
            </span>

            <p>{listing.title}</p>
          </div>
        </div>
      </div>
    </AppLink>
  );
}

export function SpecialList({ listings }) {
  if (!listings?.length) return null;

  if (listings.length < 3)
    return listings.map((listing) => (
      <Listing key={listing.id} listing={listing} />
    ));
  return (
    <div className={css.list}>
      {listings.map((listing) => (
        <SpecialListing key={listing.id} listing={listing} />
      ))}
    </div>
  );
}
export function SpecialDailyList({ listings } = { listings: [] }) {
  if (!listings?.length) return null;

  if (listings.length < 3)
    return listings.map((listing) => (
      <Listing key={listing.id} listing={listing} />
    ));
  return (
    <div className={css.list}>
      {listings.map((listing) => (
        <SpecialListing key={listing.id} listing={listing} />
      ))}
    </div>
  );
}
